import FingerprintJS from '@fingerprintjs/fingerprintjs';

class DeviceFingerprint {
  private static instance: DeviceFingerprint;
  private fingerprintPromise: Promise<string> | null = null;

  private constructor() {}

  static getInstance(): DeviceFingerprint {
    if (!DeviceFingerprint.instance) {
      DeviceFingerprint.instance = new DeviceFingerprint();
    }
    return DeviceFingerprint.instance;
  }

  async getFingerprint(): Promise<string> {
    if (!this.fingerprintPromise) {
      this.fingerprintPromise = this.generateFingerprint();
    }
    return this.fingerprintPromise;
  }

  private async generateFingerprint(): Promise<string> {
    try {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      return result.visitorId;
    } catch (error) {
      console.error('Error generating fingerprint:', error);
      // Fallback to a simple hash based on user agent and timestamp
      return this.generateFallbackFingerprint();
    }
  }

  private generateFallbackFingerprint(): string {
    // Try to get stored fallback fingerprint first
    const FALLBACK_KEY = 'device_fallback_fingerprint';
    try {
      const stored = localStorage.getItem(FALLBACK_KEY);
      if (stored) {
        console.log('[DeviceFingerprint] Using stored fallback fingerprint');
        return stored;
      }
    } catch (e) {
      console.warn('[DeviceFingerprint] Could not access localStorage:', e);
    }

    // Generate new fallback based on stable browser characteristics
    const userAgent = navigator.userAgent;
    const screenResolution = `${screen.width}x${screen.height}x${screen.colorDepth}`;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const language = navigator.language;
    const platform = navigator.platform;
    
    // Combine stable characteristics (no timestamp or random!)
    const str = `${userAgent}-${screenResolution}-${timezone}-${language}-${platform}`;
    
    // Simple hash function
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    
    const fingerprint = Math.abs(hash).toString(16);
    
    // Store for future use
    try {
      localStorage.setItem(FALLBACK_KEY, fingerprint);
      console.log('[DeviceFingerprint] Generated and stored new fallback fingerprint');
    } catch (e) {
      console.warn('[DeviceFingerprint] Could not store fallback fingerprint:', e);
    }
    
    return fingerprint;
  }

  getDeviceName(): string {
    const userAgent = navigator.userAgent;
    let deviceName = 'Unknown Device';

    if (userAgent.includes('Mac')) {
      deviceName = 'Mac';
    } else if (userAgent.includes('Windows')) {
      deviceName = 'Windows PC';
    } else if (userAgent.includes('Linux')) {
      deviceName = 'Linux PC';
    } else if (userAgent.includes('iPhone')) {
      deviceName = 'iPhone';
    } else if (userAgent.includes('iPad')) {
      deviceName = 'iPad';
    } else if (userAgent.includes('Android')) {
      deviceName = 'Android Device';
    }

    return deviceName;
  }

  getUserAgent(): string {
    const userAgent = navigator.userAgent;
    
    if (userAgent.includes('Chrome')) {
      return 'Chrome';
    } else if (userAgent.includes('Firefox')) {
      return 'Firefox';
    } else if (userAgent.includes('Safari')) {
      return 'Safari';
    } else if (userAgent.includes('Edge')) {
      return 'Edge';
    }
    
    return 'Unknown Browser';
  }

  getIpAddress(): string {
    // Since we can't get real IP from frontend, we'll use the current origin
    return window.location.origin;
  }
}

export const deviceFingerprint = DeviceFingerprint.getInstance();
